// Bookmarks tab for the Activity page.
// Query fires only when this tab is active (enabled: isActive), matching the lazy-load
// pattern from BookmarksContext.tsx. (ref: DL-003)
import { useQuery, getActivityBookmarks } from "wasp/client/operations";
import ArticleCard from "../../articles/components/ArticleCard";
import { ArticleTabSkeleton } from "./ArticleTabSkeleton";
import { EmptyTabState } from "./EmptyTabState";
import { ErrorTabState } from "./ErrorTabState";
import { ARTICLE_CARD_GRID_CLASS } from "./articleGridClass";

interface BookmarksTabProps {
  isActive: boolean;
}

export function BookmarksTab({ isActive }: BookmarksTabProps) {
  const { data, isLoading, error, refetch } = useQuery(
    getActivityBookmarks,
    undefined,
    { enabled: isActive },
  );

  if (isLoading) {
    return <ArticleTabSkeleton />;
  }

  if (error) {
    return <ErrorTabState onRetry={() => refetch()} />;
  }

  if (!data || data.length === 0) {
    return (
      <EmptyTabState
        message="Save articles you love and find them here later."
        actionLabel="Browse articles"
        actionTo="/articles"
      />
    );
  }

  return (
    <div className={ARTICLE_CARD_GRID_CLASS}>
      {data.map(({ article }) => (
        <div key={article.id}>
          <ArticleCard article={article} />
        </div>
      ))}
    </div>
  );
}
